/**
 * STYLING: Plain Tailwind ONLY!
 */

import { ArrowLeft } from 'lucide-react';
import { useTranslation } from 'react-i18next';
import { Link } from 'react-router-dom';
import { TextToolCreditBadge } from './TextToolCreditBadge';
import { TIER_COLORS } from './textToolsConfig';

const TIER_KEYS: Record<number, string> = { 1: 'tierBasis', 2: 'tierStandard', 3: 'tierPremium' };

interface TextToolHeaderProps {
  toolCode: string;
  name: string;
  description: string;
  tier: number;
  baseCredits: number;
  multipliers: Record<string, number>;
  selectedModel: string;
  promptLength?: number;
  inputSizeTiers?: [number | null, number][];
  googleSearch?: boolean;
}

export function TextToolHeader({ toolCode, name, description, tier, baseCredits, multipliers, selectedModel, promptLength, inputSizeTiers, googleSearch }: TextToolHeaderProps) {
  const { t } = useTranslation();

  return (
    <div id={`text-tool-header-${toolCode}`} className="space-y-2">
      <Link
        id={`text-tool-back-link-${toolCode}`}
        to="/v2/tools/text"
        className="inline-flex items-center gap-1 text-sm text-neutral-500 hover:text-neutral-700 dark:text-neutral-400 dark:hover:text-neutral-200"
      >
        <ArrowLeft className="h-4 w-4" />
        {t('textTools.allTextTools')}
      </Link>
      <div className="flex items-center gap-3 flex-wrap">
        <h1 id={`text-tool-heading-${toolCode}`} className="text-2xl font-bold text-neutral-900 dark:text-neutral-100">{name}</h1>
        <span id={`text-tool-tier-badge-${toolCode}`} className={`text-xs font-medium px-2 py-0.5 rounded-full ${TIER_COLORS[tier] || ''}`}>
          {t(`textTools.${TIER_KEYS[tier] || 'tierBasis'}`)}
        </span>
        <TextToolCreditBadge baseCredits={baseCredits} multipliers={multipliers} selectedModel={selectedModel} promptLength={promptLength} inputSizeTiers={inputSizeTiers} googleSearch={googleSearch} />
      </div>
      <p id={`text-tool-description-${toolCode}`} className="text-sm text-neutral-600 dark:text-neutral-400">{description}</p>
    </div>
  );
}
